import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { CrossBlackIcon } from "@/src/Asset";
import { CountryFilterButtons } from "./FilterButtons";

export default function CountrySection({
  filterData,
  setSelectedFilterCategory,
  filterOptions,
  handleModalToggle,
}: any) {
  const router = useRouter();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const [filterCountriesData, setFilterCountriesData] = useState<any[]>([]);

  const getUniqueCountries = (filteredData: any) => {
    const countriesMap = new Map();

    filteredData.forEach((college: any) => {
      if (college.country && !countriesMap.has(college.country.id)) {
        countriesMap.set(college.country.id, college.country); // Store unique cities by ID
      }
    });

    return Array.from(countriesMap.values()); // Convert Map values to an array of objects
  };

  const filterColleges = (data: any[]) => {
    return data.filter((college) => {
      const matchesCountry = college.country?.id !== 102;

      return matchesCountry;
    });
  };

  useEffect(() => {
    const filteredResults = filterColleges(filterData);

    const uniqueCountries = getUniqueCountries(filteredResults);

    setFilterCountriesData(uniqueCountries);
  }, [
    filterOptions.country,
    filterOptions.stream,
    filterOptions.course,
    filterData,
  ]);

  const handleUpdateCountry = async (url: string) => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    await router.push(`${url}`);
    setIsRedirecting(false);
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) {
      setSelectedFilterCategory(null);
    } else {
      handleModalToggle();
    }
  };

  return (
    <div>
      {/* Mobile view: */}
      <div className="lg:hidden w-full h-fit">
        {/* Header */}
        <div className="sticky top-0 bg-white text-lg font-bold text-[#334988] mb-2">
          Country
        </div>

        {/* scrollable content */}
        <div
          style={{
            overflow: "auto",
            msOverflowStyle: "none", // IE and Edge
            scrollbarWidth: "none",
          }}
          className="w-full max-h-fit sm:max-h-full overflow-x-auto overflow-y-auto flex flex-wrap sm:grid sm:grid-cols-2 gap-3 mt-4 mb-20"
        >
          <CountryFilterButtons
            filterCountriesData={filterCountriesData}
            filterOptions={filterOptions}
            handleUpdateCountry={handleUpdateCountry}
            isRedirecting={isRedirecting}
            handleModalToggle={handleModalToggle}
          />
        </div>
      </div>

      {/* Desktop view: */}
      <div className="hidden lg:block absolute mt-3 left-[9%] !z-10">
        {/* Overlay */}
        <div className="bg-white rounded-lg shadow-lg border w-[28rem] h-full overflow-y-auto">
          <div className="sticky top-0 bg-white px-4 pt-4 pb-2">
            {/* Header */}
            <div className="flex justify-between items-center mb-2">
              <div className="text-lg font-medium">Countries</div>
              <button
                onClick={() => setSelectedFilterCategory(null)}
                className="text-gray-600 hover:text-gray-900 text-2xl"
              >
                <CrossBlackIcon className="scale-75" />
              </button>
            </div>
          </div>

          {/* Scrollable Content */}
          <div className="flex flex-wrap gap-x-3 gap-y-4 justify-start px-4 pb-4">
            <CountryFilterButtons
              filterCountriesData={filterCountriesData}
              filterOptions={filterOptions}
              handleUpdateCountry={handleUpdateCountry}
              isRedirecting={isRedirecting}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
